import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import SelectedImageDisplay from "./SelectedImageDisplay";
import ThumbnailGallery from "./ThumbnailGallery";
import clsx from 'clsx';
import CatchErrors from "../../Utility/CatchErrors";

export default function ClassicProductGallery({
  selectedImage, callbacks,
  productGroup = {},
  images,
  className,
  embiggened = false,  // is the popup open? suppress video when true
  ...props
}) {

  // max-h-104 added to tailwind theme.extend.maxHeight
  className = clsx(className, "relative block min-h-4 overflow-y-hidden");

  return <div id="product-group-gallery" className={className}>
    <div className="grid grid-cols-1 md:grid-cols-4 xs:max-md:mb-1">
      <div className="md:col-span-3 md:max-h-104">
        <CatchErrors>
          <SelectedImageDisplay
            embiggened={embiggened}
            inPopup={false}
            selectedImage={selectedImage}
            productGroup={productGroup}
            callbacks={callbacks}/>
        </CatchErrors>
      </div>
      <div
        className="max-h-20 md:max-h-104 overflow-y-hidden overflow-x-scroll md:overflow-y-scroll md:overflow-x-hidden">
        <CatchErrors>
          <ThumbnailGallery
            selectedImage={selectedImage}
            images={images}
            productGroup={productGroup}
            callbacks={callbacks}/>
        </CatchErrors>
      </div>
    </div>
  </div>
}
